// docs' scope catalogue and presets, as docs-api serves them
// (`GET /api/v1/auth/scopes` → {scopes: [{scope, resource, category,
// description}], presets: {name: [scopes]}}): `resource` is what a scope acts
// on (`files`, `shares`, `signing`, `templates`, `records`, `docs`),
// `category` its group (files, sharing, signing, templates, records,
// administration); the presets are docs/ACCESS.md's personas (viewer,
// employee, records_officer, records_manager, admin). The group grants and
// the API keys name these; the console never pins a list of its own.

import { useEffect, useState } from 'react';
import { api, ep } from './api.js';

export function useScopeCatalogue() {
  const [catalogue, setCatalogue] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(ep.scopes()).then((res) => {
      if (cancelled) return;
      if (res.success) {
        setCatalogue({ scopes: res.response?.scopes || [], presets: res.response?.presets || {} });
      } else {
        setError(res.message);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { catalogue, error };
}

/** The group a catalogue entry is listed under: its category, else its resource. */
export const scopeGroupOf = (entry) => entry?.category || entry?.resource || String(entry?.scope || '').split(':')[0] || 'other';

/** A grant is a scope (`resource:action`) or a preset's name, as docs-api reads it. */
export const isScopeGrant = (grant) => String(grant).includes(':');

/** The preset whose scopes are exactly `scopes` (order and repeats aside), or null. */
export function presetMatching(scopes, presets) {
  const mine = new Set(scopes || []);
  return (
    Object.entries(presets || {}).find(([, list]) => {
      const theirs = new Set(list);
      return theirs.size === mine.size && [...theirs].every((s) => mine.has(s));
    })?.[0] || null
  );
}

/** A preset's display name: its translation, else the catalogue's own name. */
export const presetLabel = (t, name) => t(`scopes.presets.${name}`, { defaultValue: name });
